import React from "react";

export const IconLogo = ({style}) => {
    return (
        <svg
            className="icon"
            xmlns="http://www.w3.org/2000/svg"
            width="512"
            height="512"
            fill="none"
            viewBox="0 0 512 512"
            style={{...style}}>
            <path
                fillRule="evenodd"
                d="M112 77c-13.255 0-24 10.745-24 24v35.054l-40.845-20.422C36.517 110.312 24 118.048 24 129.943v157.021a15.999 15.999 0 0011.605 15.384L88 317.318v93.793c0 17.842 18.776 29.445 34.733 21.467L256 365.944l133.267 66.634c15.957 7.978 34.733-3.625 34.733-21.467v-93.793l52.396-14.97A16 16 0 00488 286.964V129.943c0-11.895-12.517-19.631-23.155-14.311L424 136.054V101c0-13.255-10.745-24-24-24h-52.669c-38.172 0-73.17 20.9-91.331 54.254C237.839 97.899 202.841 77 164.669 77H112zm296 244.89l-130.029 37.151 118.451 59.226c5.319 2.659 11.578-1.209 11.578-7.156V321.89zm-304 89.221V321.89l130.029 37.151-118.451 59.226c-5.319 2.659-11.578-1.209-11.578-7.156zm320-257.168V229c0 13.255-10.745 24-24 24h-35.949c-34.26 0-64.316 22.845-73.486 55.855A22.044 22.044 0 01269.325 325h-26.483a23.043 23.043 0 01-21.86-15.756C209.786 275.656 178.353 253 142.947 253H112c-13.255 0-24-10.745-24-24v-75.057l-48-24v157.021l216 61.714 216-61.714V129.943l-48 24zM104 197v-96a8 8 0 018-8h52.669c33.332 0 63.803 18.832 78.709 48.645l4.622 9.244v98.07C228.73 221.696 197.204 205 163.078 205H112a8 8 0 01-8-8zm0 22.634V229a8 8 0 008 8h30.947c42.293 0 79.84 27.063 93.214 67.184a7.042 7.042 0 006.681 4.816h26.483a6.045 6.045 0 005.824-4.427C286.242 264.638 322.603 237 364.051 237H400a8 8 0 008-8v-9.366a23.946 23.946 0 01-8 1.366h-51.078c-34.088 0-65.109 19.687-79.624 50.53l-6.059 12.876a8.001 8.001 0 01-14.478 0l-6.059-12.876C228.187 240.687 197.166 221 163.078 221H112c-2.805 0-5.498-.481-8-1.366zM408 197v-96a8 8 0 00-8-8h-52.669c-33.332 0-63.803 18.832-78.709 48.645L264 150.889v98.07C283.27 221.696 314.796 205 348.922 205H400a8 8 0 008-8z"
                clipRule="evenodd"
            ></path>
        </svg>
    );
}

export const IconSearch = ({style}) => {
    return (
        <svg
            className="icon"
            xmlns="http://www.w3.org/2000/svg"
            width="100"
            height="100"
            x="0"
            y="0"
            viewBox="0 0 100 100"
            style={{...style}}>
            <g>
                <path d="M87.4 77.7L68.5 58.8c3.2-5 4.7-10.8 4.7-16.5C73.2 25.4 59.7 12 42.8 12 25.2 12 11.9 25.9 12 42.6c.1 16.7 13.6 30.6 30.8 30.6 5.8 0 11.3-1.6 16.1-4.6l18.9 18.8c.8.8 2 .8 2.8 0l6.9-6.9c.7-.8.7-2-.1-2.8zm-44.6-8.5c-15 0-26.7-12.1-26.8-26.7-.1-14.4 11.4-26.6 26.8-26.6 15 0 26.3 11.7 26.4 26.3.1 15.6-12.2 27-26.4 27zm36.3 14l-17-17c.6-.5 3.4-3.3 4.1-4.1l17 17-4.1 4.1z"></path>
            </g>
            <g>
                <path
                d="M244-370v1684h-1784V-370H244m8-8h-1800v1700H252V-378z"
                ></path>
            </g>
        </svg>
    );
}

export const IconListen = ({style}) => {
    return (
        <svg
            className="icon"
            xmlns="http://www.w3.org/2000/svg"
            width="512"
            height="512"
            viewBox="0 0 512 512"
            style={{...style}}>
            <path d="M165.116 265.385c-24.495 0-44.884 17.863-48.857 41.244a36.963 36.963 0 00-7.092 2.01V272.82c0-24.876 6.244-48.313 17.222-68.856 2.885.883 5.896 1.367 8.955 1.367 8.962 0 17.45-3.895 23.288-10.686a127.827 127.827 0 0135.635-28.893 128.115 128.115 0 018.677-4.337 8.075 8.075 0 004.022-10.69 8.077 8.077 0 00-10.692-4.022 145.379 145.379 0 00-9.769 4.881c-15.257 8.359-28.757 19.303-40.125 32.529a14.534 14.534 0 01-20.503 1.549c-6.08-5.226-6.773-14.424-1.548-20.503 32.978-38.367 80.883-60.371 131.432-60.371 3.747 0 7.536.123 11.262.364 4.621.3 9.288.792 13.873 1.462a8.077 8.077 0 009.161-6.823 8.077 8.077 0 00-6.823-9.161 190.662 190.662 0 00-15.164-1.599 190.442 190.442 0 00-12.309-.399c-55.263 0-107.633 24.055-143.684 65.995-8.149 9.482-9.458 22.549-4.421 33.181-14.436 25.053-22.721 54.077-22.721 85.011v66.387c0 1.09.157 2.141.427 3.146-.014.412-.032.823-.032 1.238 0 18.361 13.246 33.676 30.683 36.917 3.287 24.17 24.047 42.86 49.104 42.86 27.334 0 49.572-22.237 49.572-49.571v-58.841c-.001-27.334-22.239-49.57-49.573-49.57zm-50.303 98.027c-7.811-3.194-13.328-10.876-13.328-19.822 0-8.947 5.517-16.628 13.328-19.822v39.644z"></path>
            <path d="M426.588 337.636V272.82c0-30.934-8.284-59.958-22.721-85.011 5.038-10.632 3.729-23.7-4.421-33.182a189.444 189.444 0 00-50.409-41.445 8.077 8.077 0 00-7.954 14.061 173.303 173.303 0 0146.113 37.915c5.226 6.079 4.529 15.276-1.548 20.503-6.082 5.225-15.28 4.529-20.505-1.548-13.315-15.489-29.406-27.754-47.83-36.454a143.886 143.886 0 00-22.453-8.397 145.368 145.368 0 00-4.525-1.197c-2.138-.677-12.891-3.855-28.543-4.563-4.424-.213-8.232 3.247-8.434 7.704a8.08 8.08 0 007.706 8.435c14.729.666 24.401 3.827 24.478 3.852.22.073.44.138.662.192a127.504 127.504 0 0113.406 4.071 128.227 128.227 0 0110.806 4.51c16.359 7.725 30.651 18.618 42.479 32.377 6.062 7.052 14.655 10.67 23.297 10.67 3.013 0 6.025-.467 8.944-1.355 10.979 20.544 17.222 43.984 17.222 68.861v35.478a37.298 37.298 0 00-7.052-1.818c-3.881-23.491-24.325-41.467-48.899-41.467-27.333 0-49.569 22.237-49.569 49.571v58.842c0 27.333 22.236 49.568 49.569 49.568 24.87 0 45.517-18.41 49.037-42.317 17.899-2.854 31.623-18.395 31.623-37.086a37.935 37.935 0 00-.479-5.954zm-80.183 69.203a33.53 33.53 0 01-3.824-.226h7.65a33.552 33.552 0 01-3.826.226zm51.178-43.427v-39.645c7.812 3.194 13.328 10.875 13.328 19.822s-5.516 16.629-13.328 19.823zm-165.64-228.275a134.797 134.797 0 00-9.063 1.8 8.078 8.078 0 103.694 15.727 118.09 118.09 0 017.971-1.584 8.076 8.076 0 10-2.602-15.943zm76.078-21.723c2.548.917 5.104 1.907 7.598 2.941a8.067 8.067 0 003.088.617 8.078 8.078 0 003.096-15.541 189.336 189.336 0 00-8.308-3.215 8.078 8.078 0 00-5.474 15.198z"></path>
        </svg>
    );
}

export const IconBook = ({style}) => {
    return (
        <svg 
            className="icon" 
            xmlns="http://www.w3.org/2000/svg" 
            viewBox="0 0 64 64"
            style={{...style}}>
            <path d="M60 9.997h-2v38.981a1 1 0 01-1 1c-21.727 0-24.002 9.11-24.022 9.203a1.004 1.004 0 01-.977.787h-.01a.997.997 0 01-.97-.79c-.034-.145-2.361-9.2-24.021-9.2a1 1 0 01-1-1V9.997H4a1 1 0 00-1 1v41.98a1 1 0 001 .999c25.644 0 26.963 5.832 27 6.046.005.09.021.179.049.263.13.408.506.715.95.715.553 0 1-.42 1-.972.007-.06 1.01-6.052 27.001-6.052a1 1 0 001-1v-41.98a1 1 0 00-1-1z"></path>
            <path d="M31 11.263C28.422 7.397 22.521 3 9 3a1 1 0 00-1 1v42.98a1 1 0 001 .999c21.61 0 21.994 11.492 22 11.998V11.263zm-2.738 34.858a1 1 0 11-1.98-.283c.004-.036.125-1.253-1.042-2.558-1.346-1.504-4.563-3.297-12.24-3.297a1 1 0 110-2c6.83 0 11.473 1.361 13.802 4.046 1.736 2 1.472 4.007 1.46 4.092zm0-13.993a1 1 0 11-1.98-.283c.004-.036.125-1.254-1.042-2.559-1.346-1.504-4.563-3.297-12.24-3.297a1 1 0 110-1.999c6.83 0 11.473 1.36 13.802 4.045 1.736 2.001 1.472 4.008 1.46 4.093zm0-13.994a1 1 0 11-1.98-.283c.004-.036.125-1.253-1.042-2.558-1.346-1.504-4.563-3.297-12.24-3.297a1 1 0 110-2c6.83 0 11.473 1.361 13.802 4.046 1.736 2 1.472 4.007 1.46 4.092zM33 59.978c.006-.506.39-11.998 22-11.998a1 1 0 001-1V4A1 1 0 0055 3c-13.522 0-19.422 4.397-22 8.263v48.714zm4.198-17.948c2.329-2.685 6.972-4.046 13.802-4.046a1 1 0 110 2c-7.677 0-10.894 1.793-12.24 3.297-1.167 1.305-1.046 2.522-1.043 2.558a1 1 0 01-1.98.283c-.011-.085-.275-2.092 1.461-4.093zm0-13.994C39.527 25.351 44.17 23.99 51 23.99a1 1 0 110 2c-7.677 0-10.894 1.792-12.24 3.296-1.167 1.305-1.046 2.523-1.043 2.559a1 1 0 01-1.98.283c-.011-.085-.275-2.092 1.461-4.093zm0-13.993C39.527 11.357 44.17 9.997 51 9.997a1 1 0 110 1.999c-7.677 0-10.894 1.793-12.24 3.297-1.167 1.305-1.046 2.522-1.043 2.558a1 1 0 01-1.98.283c-.011-.085-.275-2.091 1.461-4.092z"></path>
        </svg>
    );
}

export const IconHusnBook = ({style}) => {
    return (
        
        <svg 
            className="icon" 
            xmlns="http://www.w3.org/2000/svg" 
            viewBox="0 0 64 64"
            style={{...style}}>
             <path d="M46 47h-4a1 1 0 010-2h2.977C44.453 33.883 35.245 25 24 25S3.547 33.883 3.023 45H38.2a1 1 0 010 2H2a1 1 0 01-1-1c0-12.682 10.318-23 23-23s23 10.318 23 23a1 1 0 01-1 1zM34 10H14a1 1 0 01-1-1V2a1 1 0 011-1h20a1 1 0 011 1v7a1 1 0 01-1 1zM15 8h18V3H15v5z"/><path d="M24 22c-6.065 0-11-4.935-11-11V9a1 1 0 011-1h20a1 1 0 011 1v2c0 6.065-4.935 11-11 11zm-9-12v1c0 4.962 4.038 9 9 9s9-4.038 9-9v-1H15z"/>
        </svg>
    );
}

export const IconHorizontalLayout = ({style}) => {
    return (
        <svg
            className="icon"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            style={{...style}}>
            <path fill="none" d="M0 0h24v24H0z" data-name="Path 3624"></path>
            <path
                fill="#525863"
                d="M16.362 18.256a1.9 1.9 0 111.895 1.9 1.894 1.894 0 01-1.895-1.9zm-6.229 0a1.895 1.895 0 111.895 1.9 1.894 1.894 0 01-1.895-1.9zm-6.232 0a1.9 1.9 0 111.895 1.9 1.894 1.894 0 01-1.896-1.9zm12.461-6.229a1.9 1.9 0 111.895 1.894 1.9 1.9 0 01-1.895-1.894zm-6.229 0a1.895 1.895 0 111.895 1.894 1.9 1.9 0 01-1.895-1.894zm-6.232 0a1.9 1.9 0 111.895 1.894A1.9 1.9 0 013.9 12.027zm12.461-6.233a1.9 1.9 0 111.895 1.9 1.894 1.894 0 01-1.895-1.9zm-6.229 0a1.895 1.895 0 111.895 1.9 1.894 1.894 0 01-1.895-1.9zm-6.232 0a1.9 1.9 0 111.895 1.9 1.894 1.894 0 01-1.896-1.9z"
                data-name="Path 2657"
            ></path>
        </svg>
    );
}

export const IconVerticalLayout = ({style}) => {
    return (
        <svg 
            className="icon"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            style={{...style}}>
            <g data-name="Layer 2">
                <g data-name="menu">
                <rect width="18" height="2" x="3" y="11" rx="0.95" ry="0.95"></rect>
                <rect width="18" height="2" x="3" y="16" rx="0.95" ry="0.95"></rect>
                <rect width="18" height="2" x="3" y="6" rx="0.95" ry="0.95"></rect>
                </g>
            </g>
        </svg>
    );
}

export const IconHeart = ({style, borderColor, subBorderColor, fill = "none"}) => {
    return (
        <svg
            className="icon"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 64 64"
            style={{...style}}>
            <g fill="none" data-name="Layer 2">
                <path
                    fill={fill}
                    stroke={borderColor}
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M32 50L16.34 34.34C3.69 21.69 19.35 6 32 18.67 44.64 6 60.3 21.7 47.67 34.34z"
                ></path>
                <path
                    fill={fill}
                    stroke={subBorderColor}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M16 24.33A7 7 0 0123 18m-4 12.74a7 7 0 01-2.06-2.25"
                ></path>
                <path d="M0 0H64V64H0z"></path>
            </g>
        </svg>
    );
}

export const IconAvatar = ({style}) => {
    return (
        <svg className="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" style={{...style}}>
            <path d="M46 47h-4a1 1 0 010-2h2.977C44.453 33.883 35.245 25 24 25S3.547 33.883 3.023 45H38.2a1 1 0 010 2H2a1 1 0 01-1-1c0-12.682 10.318-23 23-23s23 10.318 23 23a1 1 0 01-1 1zM34 10H14a1 1 0 01-1-1V2a1 1 0 011-1h20a1 1 0 011 1v7a1 1 0 01-1 1zM15 8h18V3H15v5z"></path>
            <path d="M24 22c-6.065 0-11-4.935-11-11V9a1 1 0 011-1h20a1 1 0 011 1v2c0 6.065-4.935 11-11 11zm-9-12v1c0 4.962 4.038 9 9 9s9-4.038 9-9v-1H15z"></path>
        </svg>
    );
}

export const IconMicrophone = ({style}) => {
    return (
        <svg 
            className="icon"
            xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"
            style={{...style}}>
            <path d="M26 15a1 1 0 00-1 1 9 9 0 01-18 0 1 1 0 00-2 0 11 11 0 0010 11v3a1 1 0 002 0v-3a11 11 0 0010-11 1 1 0 00-1-1z"></path>
            <path d="M16 21a6 6 0 006-6V7a6 6 0 00-12 0v8a6 6 0 006 6z"></path>
        </svg>
    );
}

export const IconLike = ({style}) => {
    return (
        <svg
            className="icon"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 80 80"
            style={{...style}}>
            <path d="M75 32.548c0-3.916-3.186-7.101-7.1-7.101H50.061c1.311-4.285 2.868-12.455-2.189-17.435-1.526-1.502-3.468-2.352-5.469-2.394-2.016-.048-3.773.675-5.082 2.074a4.136 4.136 0 00-1.108 2.838v.711c0 7.31-3.331 14.08-8.91 18.107a21.165 21.165 0 01-5.381 2.812 3.366 3.366 0 00-3.353-3.188H8.371A3.375 3.375 0 005 32.342v38.67a3.375 3.375 0 003.371 3.371h10.2a3.375 3.375 0 003.37-3.37V69.64c5.945 1.004 12.078 1.509 18.369 1.509 7.033 0 14.262-.628 21.636-1.884a6.902 6.902 0 006.71-6.891 6.848 6.848 0 00-.793-3.2c2.877-.88 4.977-3.56 4.977-6.721 0-1.48-.462-2.85-1.245-3.984A6.885 6.885 0 0075 42.537c0-1.942-.81-3.694-2.107-4.948A7.078 7.078 0 0075 32.548zM17.941 70.383H9V32.972h8.941v37.411zM68.112 39.65c1.592 0 2.888 1.295 2.888 2.888s-1.296 2.887-2.888 2.887H56.277a2 2 0 000 4h9.535a3.031 3.031 0 013.028 3.029 3.031 3.031 0 01-3.028 3.027h-6.947a2 2 0 000 4h2.898a2.896 2.896 0 012.893 2.894 2.897 2.897 0 01-2.893 2.893c-.114 0-.227.01-.338.029-13.827 2.371-27.101 2.46-39.484.28V36.361a25.032 25.032 0 007.705-3.77c6.617-4.777 10.568-12.758 10.568-21.35v-.711a.18.18 0 01.03-.105c.525-.562 1.212-.83 2.077-.808.976.02 1.95.463 2.745 1.246 4.918 4.842.49 15.397.33 15.769-.1.222-.156.465-.168.72 0 .026-.007.052-.008.077l-.001.018c0 .068.013.133.02.2.006.06.007.12.018.177.013.07.037.136.057.203.018.058.031.117.054.172.022.056.053.106.08.159.033.064.063.13.103.19.023.035.052.065.077.098.053.072.107.143.17.207.018.018.04.033.058.05.076.072.154.14.242.2.01.007.02.01.03.017.092.06.185.118.289.163.276.122.564.17.847.164H67.9c1.71 0 3.101 1.39 3.101 3.1s-1.39 3.102-3.1 3.102H54.982a2 2 0 000 4h13.129z"></path>
        </svg>
    );
}

export const IconCheck = ({style}) => {
    return (
        <svg 
            className="icon"
            xmlns="http://www.w3.org/2000/svg" 
            width="24"
            height="24"
            style={{...style}}>
            <path fill="none" d="M0 0h24v24H0V0z"></path>
            <path d="M9 16.17L5.53 12.7a.996.996 0 10-1.41 1.41l4.18 4.18c.39.39 1.02.39 1.41 0L20.29 7.71a.996.996 0 10-1.41-1.41L9 16.17z"></path>
        </svg>
    );
}

export const IconPlay = ({style, color}) => {
    return (
        <svg 
            className="icon"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            style={{...style}}>
            <path
                d="M8.4 17.77a1 1 0 01-.47-.12 1 1 0 01-.53-.88V7.23A1 1 0 019 6.39l7.2 4.78a1 1 0 010 1.66L9 17.61a1 1 0 01-.6.16zm1-8.68v5.82L13.79 12z"
            ></path>
        </svg>
    );
}

export const IconShare = ({style}) => {
    return (
        <svg
            className="icon"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 6.35 6.35"
            style={{...style}}>
            <path
                d="M3.694 1.324a.798.798 0 00-.783.794v.135h-.265c-1.152 0-1.798.652-2.092 1.274-.293.623-.29 1.235-.29 1.235a.265.265 0 00.466.173s.716-.83 1.916-.83h.265v.128c0 .619.719 1.005 1.234.661l1.587-1.058a.801.801 0 000-1.321L4.145 1.456a.793.793 0 00-.451-.132zm.007.53a.251.251 0 01.15.043L5.44 2.955c.165.11.165.33 0 .44l-1.59 1.06c-.188.125-.41.005-.41-.221V3.84a.265.265 0 00-.265-.265h-.53c-.74 0-1.317.26-1.716.52.034-.118.045-.22.103-.343.236-.5.648-.97 1.613-.97h.53a.265.265 0 00.265-.265v-.4a.26.26 0 01.26-.265z">
            </path>
        </svg>
    );
}

export const IconPause = ({style}) => {
    return (
        <svg
            className="icon"
            xmlns="http://www.w3.org/2000/svg"
            width="512"
            height="512"
            viewBox="0 0 512 512"
            style={{...style}}>
            <path d="M191 112v288h-47V112h47m16-16h-79v320h79V96zm161 16v288h-47V112h47m16-16h-79v320h79V96z"></path>
        </svg>
    );
}

export const IconClose = ({style}) => {
    return (
        <svg
            className="icon"
            xmlns="http://www.w3.org/2000/svg"
            width="48"
            height="48"
            viewBox="0 0 48 48"
            style={{...style}}>
            <path d="M38 12.83L35.17 10 24 21.17 12.83 10 10 12.83 21.17 24 10 35.17 12.83 38 24 26.83 35.17 38 38 35.17 26.83 24z"></path>
            <path fill="none" d="M0 0h48v48H0z"></path>
        </svg>
    );
}

export const IconLeft = ({style}) => {
    return (
        <svg
            className="icon"
            xmlns="http://www.w3.org/2000/svg"
            data-name="Layer 1"
            viewBox="0 0 512 512"
            style={{...style}}>
            <g data-name="&lt;Group&gt;">
                <path
                d="M145 279L449 279 449 233 145 233 145 174.182 63.121 256.061 145 337.939 145 279z"
                data-name="&lt;Path&gt;"
                ></path>
            </g>
        </svg>
    );
}

export const IconDownload = ({style}) => {
    return (
        <svg
            className="icon"
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="22"
            viewBox="0 0 20 22"
            style={{...style}}>
            <path
                fill="none"
                fillRule="evenodd"
                stroke="#000"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M0 15v3a2 2 0 002 2h14a2 2 0 002-2v-3M5 10l4 4 4-4M9 0v14"
                transform="translate(1 1)"
            ></path>
        </svg>
    );
}